import { render } from "./TravelRules.vue?vue&type=template&id=eb153ba6&scoped=true"
import script from "./TravelRules.vue?vue&type=script&lang=js"
export * from "./TravelRules.vue?vue&type=script&lang=js"

import "./TravelRules.vue?vue&type=style&index=0&id=eb153ba6&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb153ba6"]])

export default __exports__